import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AssetsManagerService } from '@barthauer/abc/core/assets-manager';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { AbcCoreContainerService } from '@barthauer/abc/ui-components';
import { QrCodeScannerState } from '../models/webapi-info.model';
import { QrCodeOverlay } from './qr-code-overlay/qr-code-overlay.component';

declare var Html5Qrcode: any;

@Component({
  selector: 'abc-authentication-qr-code-scanner',
  templateUrl: './qr-code-scanner.component.html',
  styleUrls: ['./qr-code-scanner.component.scss'],
})
export class QrCodeScannerComponent implements OnInit, OnDestroy {
  @ViewChild('qrCodeScanner', { static: false }) qrCodeScanner: ElementRef;

  private observer: MutationObserver;
  public res = ResourceSet.Empty;
  private mainContainerDiv: HTMLElement;
  private html5QrCode: any;
  public result: string;
  public onInvisible: (state: QrCodeScannerState) => void;

  constructor(
    private assetsManager: AssetsManagerService,
    private resourceService: ResourceManagerService,
    private changeDetector: ChangeDetectorRef,
    private abcCoreContainerService: AbcCoreContainerService
  ) {}

  async ngOnInit() {
    this.res = await this.resourceService.getResourceSet('abc-core-authentication');
    this.loadDependecies();
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  public startScanning() {
    this.setMainVisibility(true);
    this.changeDetector.detectChanges();

    const config = { fps: 10, aspectRatio: 1.0 };
    this.html5QrCode = new Html5Qrcode('qrCodeScanner');

    this.createQrCodeOverlay();

    this.html5QrCode.start({ facingMode: 'environment' }, config, (decodedText, decodedResult) => {
      this.result = decodedText;
      this.setMainVisibility(false);

      if (this.onInvisible) {
        this.onInvisible(QrCodeScannerState.Successfull);
        this.cancel();
      }
    });
  }

  public cancel() {
    if (this.html5QrCode) {
      this.html5QrCode
        .stop()
        .then(() => {
          this.html5QrCode.clear();
          this.html5QrCode = null;
        })
        .then(() => {
          this.setMainVisibility(false);
          if (this.onInvisible) {
            this.onInvisible(QrCodeScannerState.Canceled);
          }
        })
        .catch((err) => {});
    }
  }

  private setMainVisibility(visible: boolean) {
    if (visible) {
      this.mainContainerDiv.style.position = null;
      this.mainContainerDiv.style.visibility = 'visible';
    } else {
      this.mainContainerDiv.style.position = 'fixed';
      this.mainContainerDiv.style.visibility = 'hidden';
    }
  }

  private loadDependecies() {
    this.mainContainerDiv = document.getElementById('qrCodeScannerContainer');
    this.assetsManager.loadDependencies(['assets/scripts/html5-qrcode/html5-qrcode.min.js']);
  }

  private createQrCodeOverlay = (): void => {
    const qrCodeScanner = this.qrCodeScanner.nativeElement;

    this.observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const qrCodeBox = document.getElementById('qr-canvas');

          if (qrCodeBox) {
            this.observer?.disconnect();

            const existingOverlay = qrCodeScanner.querySelector('.qr-code-overlay');
            if (!existingOverlay) {
              const qrCodeOverlayComponentRef = this.abcCoreContainerService.createComponent(null, QrCodeOverlay);
              qrCodeScanner.appendChild(qrCodeOverlayComponentRef.domElement);
            }
          }
        }
      }
    });

    if (qrCodeScanner) {
      this.observer.observe(qrCodeScanner, { childList: true, subtree: true });
    }
  };
}
